import { signOut } from 'aws-amplify/auth';

import useAsync from './useAsync';
import { getTenantFromUrl } from '../utils/tenant';

export default function useSignOut() {
  const [{ loading: signingOut }, signOutRequest] = useAsync();

  function handleSignOut({ inactivity = false } = {}) {
    signOutRequest({
      promise: () => signOut(),
      onSuccess: () => {
        // Ensure tenant is saved to localStorage before clearing
        const tenant = getTenantFromUrl();
        localStorage.clear();
        // Restore tenant after clearing so auth portal can read it
        if (tenant) {
          localStorage.setItem('tenant', tenant);
        }
        window.location.assign(
          `${tenant === 'initio'
            ? process.env.REACT_APP_AUTH_HOSTNAME
            : process.env.REACT_APP_REDWOODSEED_AUTH_HOSTNAME
          }${inactivity ? '?inactivity=true' : ''}`
        );
      },
    });
  }

  return [handleSignOut, signingOut];
}
